import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, CreditCard } from 'lucide-react';

/** Sur le côté des pages Paiement et Messages : lien vers la page Paramètres paiement (où sont tous les réglages). */
const PaymentSettingsLink = () => (
    <Link to='/parametres_paiement' className='pset-link'>
        <CreditCard size={20} />
        <span>
            <b>Paramètres paiement</b>
            <small>Projets, moyens, Stripe, règles</small>
        </span>
        <ChevronRight size={18} />
    </Link>
)

export default PaymentSettingsLink
